import { render, staticRenderFns } from "./Asidebar.vue?vue&type=template&id=3993c067&scoped=true"
import script from "./Asidebar.vue?vue&type=script&lang=js"
export * from "./Asidebar.vue?vue&type=script&lang=js"
import style0 from "./Asidebar.vue?vue&type=style&index=0&id=3993c067&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993c067",
  null
  
)

export default component.exports